import CardKit from "@/shared/components/kit/card";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { useState } from "react";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import { SelectChangeEvent } from "@mui/material";
import CustomSelect from "@/shared/components/common/select";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import {
  numberSeparator,
  toPersianNumber,
} from "@/hooks/useThousandsSeparator";
import moment from "jalali-moment";
/**
 * Transactions
 *
 * نمایش لیست تراکنش‌های کیف پول کاربر.
 *
 * - دریافت داده‌ها از props `data`.
 * - نمایش تاریخ تراکنش به فرمت شمسی با استفاده از moment-jalali.
 * - نمایش وضعیت تراکنش (موفق، در انتظار پرداخت، ناموفق) با آیکون رنگی.
 * - نمایش مبلغ تراکنش با جداکننده هزارگان و واحد ریال.
 * - امکان انتخاب تعداد تراکنش‌های نمایش داده شده از طریق CustomSelect.
 *
 * @param {Object} props
 * @param {any} props.data داده‌های تراکنش‌ها
 *
 * @returns JSX.Element
 */

const Transactions = ({ data }: { data: any }) => {
  const [value, setValue] = useState("موجودی نقدی : 5,000,000 ریال");

  const handleChange = (event: SelectChangeEvent) => {
    setValue(event.target.value);
  };

  return (
    <CardKit
      sx={{
        background: "#fff",
      }}
      width={"100%"}
      height={468}
      title={
        <StackKit
          justifyContent={"space-between"}
          sx={{ flexDirection: { md: "column", lg: "row !important" } }}
        >
          <StackKit direction={"row"} gap={1} alignItems={"center"}>
            <ReceiptLongOutlinedIcon style={{ color: "#082A2E" }} />
            <TypoGraphyKit variant="header">تراکنش ها</TypoGraphyKit>
          </StackKit>
          <CustomSelect
            sx={{ bgcolor: "#EAEAEA" }}
            label={
              <TypoGraphyKit variant="body1" sx={{ color: "#082A2E" }}>
                تراکنش آخر
              </TypoGraphyKit>
            } value={10} options={[10]} onChange={(val) => console.log("selected:", val)}
          />
        </StackKit>
      }
    >
      <StackKit
        sx={{
          width: "100%",
          justifyContent: "flex-start",
          alignItems: "center",
          maxHeight: "387px",
          overflow: "auto",
        }}
      >
        {data?.data?.transfers.map((item: any) => {
          const data = toPersianNumber(
            moment(item.created_at).locale("fa").format(" MMMM "),
          );
          const dataDay = toPersianNumber(
            moment(item.created_at).locale("fa").format(" D "),
          );
          const day = moment(item.created_at).locale("fa").format("dddd");

          return (
            <StackKit
              key={item.id}
              direction={"row"}
              justifyContent={"space-between"}
              sx={{ width: "100%", padding: "20px 0px" }}
              alignItems={"center"}
            >
              <StackKit
                justifyContent={"start"}
                alignItems={"flex-start"}
                sx={{ position: "relative", width: "30%" }}
              >
                <StackKit direction={"row"} gap={1}>
                  <TypoGraphyKit variant="body1">{dataDay}</TypoGraphyKit>

                  <TypoGraphyKit variant="body1">{data}</TypoGraphyKit>
                </StackKit>
                <TypoGraphyKit
                  component={"span"}
                  variant="body1"
                  sx={{
                    fontSize: "8px",
                    position: "absolute",
                    bottom: "-10px",
                  }}
                >
                  {day}
                </TypoGraphyKit>
              </StackKit>
              <StackKit
                direction={"row"}
                sx={{ width: "30%", margin: "0 !important" }}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <TypoGraphyKit
                  variant="body1"
                  sx={{ fontSize: "8px", color: "#A4A4A4" }}
                >
                  {item.status === "success" || item.status === 1
                    ? "شارژ موفق"
                    : item.status === 0
                      ? "شارژ درانتظار پرداخت"
                      : "شارژ ناموفق"}
                </TypoGraphyKit>
                <FileDownloadOutlinedIcon
                  style={{
                    color:
                      item.status === "success" || item.status === 1
                        ? "green"
                        : "red",
                  }}
                />
              </StackKit>
              <StackKit
                direction={"row"}
                alignItems={"center"}
                sx={{
                  width: { xs: "50%", sm: "45%", md: "40%" },
                  margin: "0!important",
                }}
                justifyContent={"end"}
                gap={1}
                flexWrap={"wrap"}
              >
                <TypoGraphyKit variant="h6">
                  {numberSeparator(item.amount)}
                </TypoGraphyKit>
                <TypoGraphyKit
                  variant="body1"
                  sx={{ fontSize: "8px", margin: "0!important" }}
                >
                  ریال
                </TypoGraphyKit>
              </StackKit>
            </StackKit>
          );
        })}
      </StackKit>
    </CardKit>
  );
};

export default Transactions;
